import React from "react";

export default function DinnerMoonIcon({ className = "w-3.5 h-3.5", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.604 12.902"
      className={className}
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#dinner-moon-clip)">
        <path
          d="M10.939,10.274a.556.556,0,0,0-.518-.139H10.4A4.948,4.948,0,0,1,4.012,5.466,5.024,5.024,0,0,1,6.687,1.005.517.517,0,0,0,6.95.4.515.515,0,0,0,6.44,0H6.409A6.414,6.414,0,0,0,0,6.386c0,.131,0,.263.008.394a6.394,6.394,0,0,0,2.134,4.492A6.529,6.529,0,0,0,6.463,12.9a3.1,3.1,0,0,0,.379-.015A6.392,6.392,0,0,0,9.5,12.13a6.2,6.2,0,0,0,1.43-1.09.539.539,0,0,0,.008-.765m-.789.6a5.585,5.585,0,0,1-.966.68,5.8,5.8,0,0,1-6.61-.781A5.714,5.714,0,0,1,.665,6.749,5.767,5.767,0,0,1,5.976.665,5.69,5.69,0,0,0,3.355,5.473a5.615,5.615,0,0,0,5.6,5.535h.07a6.157,6.157,0,0,0,1.121-.131"
          fill="currentColor"
        />
        <path
          d="M13.917,6.89a.774.774,0,0,1-.68-.835.325.325,0,1,0-.649.008.767.767,0,0,1-.673.827.329.329,0,0,0-.008.657.77.77,0,0,1,.68.835.325.325,0,1,0,.649-.008.767.767,0,0,1,.673-.827.329.329,0,0,0,.008-.657m-.835.332a1.243,1.243,0,0,0-.17.178.927.927,0,0,0-.17-.178,1.853,1.853,0,0,0,.17-.186c.054.062.108.124.17.186"
          transform="translate(-2.63 -1.3)"
          fill="currentColor"
        />
        <path
          d="M11.736,3.654h-.008A1.073,1.073,0,0,1,10.777,2.5a.325.325,0,1,0-.649.008,1.076,1.076,0,0,1-.943,1.144.327.327,0,0,0-.325.325.332.332,0,0,0,.317.332,1.064,1.064,0,0,1,.951,1.152.327.327,0,0,0,.325.325.33.33,0,0,0,.325-.34,1.058,1.058,0,0,1,.943-1.136.328.328,0,0,0,.325-.332.324.324,0,0,0-.309-.325m-.928.325a1.694,1.694,0,0,0-.356.387,1.694,1.694,0,0,0-.356-.387,1.833,1.833,0,0,0,.356-.379,1.833,1.833,0,0,0,.356.379"
          transform="translate(-2.011 -0.492)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
